
import { useSyncExternalStore } from "react";
import TOTPService from "../TOTP";
import { get } from "immutable";

const getSnapshot = () => {
    return TOTPService.getReactSnapshot();
}

const subscribe = (callback) => {
    return TOTPService.subscribeReact(callback);
}


const checkTotpCode = async ({ code, remember  }) => {
    return TOTPService.checkTotpCode({ code, remember });
}


const getQRCode = async () => {
    return TOTPService.getQRCode();
}

const checkQRCode = async ({ otp }) => {
    return TOTPService.checkQRCode({ otp });
}

const confirmChallenge = async () => {
    return TOTPService.confirmChallenge();
}

const checkRememberedTOTP = async () => {
    return TOTPService.checkRememberedTOTP();
}

const sendTokenEmail = async () => {
    return TOTPService.sendTokenEmail();
}

export default function useTotp() {
    const { error, setupRequired, tokenEmailSend } = useSyncExternalStore(subscribe, getSnapshot);

    return {
        checkTotpCode, error, setupRequired, getQRCode, checkQRCode, confirmChallenge, checkRememberedTOTP, tokenEmailSend, sendTokenEmail
    }
}